import moment from 'moment';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useEffect, useState } from "react";
import S3 from 'react-aws-s3';
import { useNavigate, useParams } from "react-router-dom";
import { DotLoaderOverlay } from 'react-spinner-overlay';
import { format } from 'rut.js';

/** MUI */
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Collapse from '@mui/material/Collapse';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuItem from "@mui/material/MenuItem";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import { styled } from '@mui/material/styles';


/** Servicios */
import documentalService from "../services/documental.service";
import emailService from "../services/email.service";
import mutuoService from "../services/mutuo.service";
import personaService from "../services/persona.service";

/** Definiciones */
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const MutuoFinanzas = () => {
    const [persona, setPersona] = useState('');
    const { id_mutuo } = useParams();
    const [expanded, setExpanded] = useState(false);
    const [comentario, setComentario] = useState('');
    const [mutuo, setMutuo] = useState('');
    const [documentos, setDocumentos] = useState([]);
    //const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [archivo, setArchivo] = useState(null);
    const [url, setUrl] = useState(null);

    useEffect(() => {
        //if (!user) return navigate("/login");
        retreiveMutuo(id_mutuo);
    }, []);

    async function retreviePersona(_rut) {
        try {
            const pers = await personaService.getPorRut(_rut);
            setPersona(pers.data[0]);
        } catch (e) {
            console.error(e);
        }
    }

    async function retreiveMutuo(_id) {
        setLoading(true);
        try {
            const mutuo = await mutuoService.getByID(_id);
            console.log("Mutuo", mutuo.data);
            setMutuo(mutuo.data);
            setPersona(mutuo.data.persona);
            var _rut = format(mutuo.data.persona.Rut, { dots: false });
            const docs = await documentalService.getPorRut(_rut);
            const docs_filter = docs.data.filter(v => v.name.includes("CONTRATO"));
            setDocumentos(docs_filter);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const enviar = () => {
        if (!url) {
            alert("Debe ingresar la carta de mutuo acuerdo!!");
            return;
        } else {
            setLoading(true);
            console.log("Comentario", comentario);
            mutuoService.update(mutuo.id, { comentario_final: comentario })
                .then(response => {
                    console.log(response);
                    var html = crearHtmlMutuoAcuerdo(new Date(), mutuo.id, persona);
                    const data_email = {
                        mensaje: html,
                        email: ["plagues@ecora.cl", "grojas@ecora.cl"]
                    }
                    emailService.sendMailMutuo(data_email)
                        .then(resp => {
                            console.log(resp);
                            setLoading(false);
                            enqueueSnackbar("Solicitud enviada correctamente!!", { variant: "success" });
                            setTimeout(() => {
                                navigate("/salidar");
                            }, 2000);
                        }).catch(err => {
                            console.error(err);
                            setLoading(false);
                        });
                }).catch(err => {
                    console.error(err);
                    setLoading(false);
                    enqueueSnackbar("Ha ocurrido un error!", { variant: "error" });
                });
        }
    }

    function crearHtmlMutuoAcuerdo(fecha, id_mutuo, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Solicitud de Información de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha comentado la Solicitud de Información de Mutuo Acuerdo para la persona: ${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</p><p>Para su revisón, por favor ir al siguiente Link: <a href="${baseurl}/mutuogerencia/${id_mutuo}">REVISAR MUTUO ACUERDO</a></p> \n`;
        html = html + "</div>";
        return html;
    };

    const abrirRuta = (ruta) => {
        window.open(ruta, "_blank");
    };

    const adjuntarCarta = async () => {
        setLoading(true);
        try {
            //Guardamos documento en S3 AWS
            var dir = persona.Rut.replace(/\./g, '');
            const config = {
                bucketName: 'docreclutav2',
                dirName: dir + "/hojavida",
                acl: 'public-read',
                //dirName: 'photos', /* optional */
                region: 'sa-east-1',
                accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
                secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY
            }
            const ReactS3Client = new S3(config);
            var extension = archivo[0].name.split('.').pop();
            var ruta = "";
            window.Buffer = window.Buffer || require("buffer").Buffer;
            var nombre_archivo = "CARTA_MUTUO_ACUERDO";
            let doc = await ReactS3Client.uploadFile(archivo[0], nombre_archivo + "." + extension);
            let updateURL = await mutuoService.update(mutuo.id, { url: doc.location });
            setUrl(updateURL);
            setLoading(false);
            enqueueSnackbar("Archivo subido correctamente!!", { variant: "success" });
        } catch (error) {
            console.error(error);
            setLoading(false);
            enqueueSnackbar("Ha ocurrido un Error!!", { variant: "error" });
        }


    }

    return (
        <Container component="main" maxWidth="xs">
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Card sx={{ maxWidth: 600 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {persona ? persona.perNombre1.charAt(0).toUpperCase() : ""}
                        </Avatar>
                    }
                    /* action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    } */
                    title={persona.perNombre1 + " " + persona.perApPaterno + " " + persona.perApMaterno}
                    subheader={persona.Rut}
                />
                <CardMedia
                    component="img"
                    height="194"
                    image="/logo512.png"
                    alt="Ecora S.A."
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        {/* <p><strong>Causal:</strong> {causal.descripcion}</p>
                        <p><strong>Comentarios:</strong> {causal.comentario}</p>
                        <p><strong>Evaluación:</strong> {causal.evaluacion}</p>
                        <p><strong>Fecha Ingreso Desvinculación:</strong> {moment(causal.fecha_ingreso).format("DD-MM-YYYY")}</p> */}
                    </Typography>
                </CardContent>
                <Typography variant='6' sx={{
                    fontStyle: "inherit",
                    fontWeight: "bold",
                    textAlign: "center"
                }} paragraph>
                    Datos Trabajador
                </Typography>
                <CardContent>
                    <Typography paragraph>
                        <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                        <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                        <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                    </Typography>
                </CardContent>
                <Typography variant='6' sx={{
                    fontStyle: "inherit",
                    fontWeight: "bold",
                    textAlign: "center"
                }} paragraph>
                    Comentarios Iniciales
                </Typography>
                <CardContent>
                    <Typography paragraph>
                        <p>{mutuo.comentario_inicial}</p>
                    </Typography>
                </CardContent>
                {documentos.length > 0 ? (
                    <Box sx={{
                        margin: 3
                    }}>
                        <Typography paragraph>
                            <p>Documentos Contractuales (click para ver)</p>
                        </Typography>
                        {documentos.map(d => {
                            return (
                                <MenuItem value={d.name} onClick={() => abrirRuta(d.ruta)}>{d.name}</MenuItem>
                            )
                        })}
                    </Box>
                ) : ""}

                <Box sx={{
                    margin: 3,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold",
                        textAlign: "left"
                    }} paragraph>
                        Comentario:
                    </Typography>
                    {/* <TextField
                        label="Comentarios"
                        fullWidth
                        multiline
                        rows={4}
                        onChange={(e) => setComentario(e.target.value)}
                    /> */}
                    <Typography variant="h6" paragraph sx={{
                        fontStyle: "inherit",
                        fontWeight: "normal",
                        fontSize: 16,
                        justifyContent: 'center'
                    }}>
                        Comuníquese con quien corresponda para llegar a acuerdo en montos y plazos, una vez definido, adjunte
                        carta para aprobación de Gerencia General.
                    </Typography>
                    <Stack direction="row" spacing={2}>
                        <input type="file" multiple accept="application/pdf" placeholder="Aduntar carta de mutuo acuerdo" onChange={(e) => setArchivo(e.target.files)} />
                        <Button variant="contained" onClick={adjuntarCarta}>Adjuntar</Button>
                    </Stack>
                </Box>
                <Box sx={{
                    margin: 3,
                    alignItems: 'end',
                    justifyContent: 'end',
                    display: 'flex'
                }}>
                    <Button variant="contained" color="success" onClick={enviar}>Enviar</Button>
                </Box>
                {/* <CardActions disableSpacing>

                    <IconButton aria-label="add to favorites">
                        <FavoriteIcon />
                    </IconButton>
                    <IconButton aria-label="share">
                        <ShareIcon />
                    </IconButton>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions> */}
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>
                            <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                            <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                            <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                        </Typography>
                    </CardContent>
                </Collapse>
            </Card>
        </Container>
    )
}

export default function MutuoFinanzasSnack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <MutuoFinanzas />
        </SnackbarProvider>
    )
};